import React, { useEffect } from "react";
import { I18nextProvider } from "react-i18next";
import i18n, { getLanguageFromPath, type Language } from "../i18n";

type Props = {
  children: React.ReactNode;
  pathname: string;
};

// TZ-684 — sets the active language based on the URL.
// /en/... renders English, /uk/... Ukrainian, everything else Polish.
const I18nProvider: React.FC<Props> = ({ children, pathname }) => {
  const language: Language = getLanguageFromPath(pathname) as Language;

  // We set the language synchronously, BEFORE render — otherwise the server
  // generates HTML with Polish copy while the client hydrates with English.
  // React would report a hydration mismatch and rewrite the DOM, producing a
  // visible flash of content.
  if (i18n.language !== language) {
    i18n.changeLanguage(language);
  }

  // Client-side navigation (<Link>) does not reload the page, so the language
  // change has to be caught up with after the route changes.
  useEffect(() => {
    if (i18n.language !== language) {
      i18n.changeLanguage(language);
    }
  }, [language]);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};

export default I18nProvider;
